<div class="bug-report-dialog">
  <div class="dialog-header">
    <h2 mat-dialog-title>Report Bug</h2>
    <button mat-icon-button
            mat-dialog-close
            class="close-button"
            [disabled]="isSubmitting">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="dialog-content">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="bug-report-form">
      <div class="description-input-container">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Description</mat-label>
          <textarea matInput
                    cdkFocusInitial
                    formControlName="description"
                    placeholder="What went wrong?"
                    rows="6"
                    maxlength="5000"></textarea>
        </mat-form-field>

        <!-- Voice Input Button -->
        <button type="button"
                mat-icon-button
                class="voice-button"
                *ngIf="isSpeechSupported"
                [class.recording]="isRecording"
                (click)="startRecording()"
                matTooltip="{{ isRecording ? 'Stop recording' : 'Voice input' }}">
          <mat-icon>{{ isRecording ? 'stop' : 'mic' }}</mat-icon>
        </button>
      </div>

      <div class="recording-indicator" *ngIf="isRecording">
        <mat-icon class="pulse">fiber_manual_record</mat-icon>
        <span>Recording...</span>
      </div>
    </form>

    <div class="context-note">Includes player state, {{ logCount }} log entries</div>
  </div>

  <div mat-dialog-actions class="dialog-actions">
    <button mat-button
            type="button"
            mat-dialog-close
            [disabled]="isSubmitting"
            class="cancel-button">
      Cancel
    </button>

    <button mat-raised-button
            color="primary"
            (click)="onSubmit()"
            [disabled]="form.invalid || isSubmitting"
            class="submit-button">
      <mat-spinner *ngIf="isSubmitting" diameter="20"></mat-spinner>
      Send
    </button>
  </div>
</div>
